module.exports = "/fonts/vendor/desiigner-svg/svg/fontawesome/light/smoking-ban.svg?b0edf6dce5fe795a84e83e3aa14645a2";